module.exports = __webpack_public_path__ + "./assets/0-025ee5.bmp";


//////////////////
// WEBPACK FOOTER
// ./assets/0.bmp
// module id = 18
// module chunks = 0